export default __webpack_public_path__ + "static/media/subtract-circle.e2eaff95.svg";